// const checkNotification = async () => {
//   let notification = await navigator.serviceWorker
//     .getRegistration()
//     .then((registration) => {
//       return registration.pushManager.getSubscription().then((subscription) => {
//         return subscription;
//       });
//     });
//   return notification;
// };

// export default checkNotification;
const checkNotification = async () => {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      console.warn("No hay service worker registrado");
      return null;
    }

    if (!registration.pushManager) {
      console.warn("PushManager no soportado en este navegador");
      return null;
    }

    const subscription = await registration.pushManager.getSubscription();
    return subscription;
  } catch (err) {
    console.error("Error comprobando notificaciones push:", err);
    return null;
  }
};

export default checkNotification;